export const isEventsBannerHiddenSelector = state => state.cookieHandler.get('isEventBannerHidden')
export const getAdsTrackingInfoSelector = state => state.cookieHandler.get('adsTrackingInfo')
export const possibleLoanIdSelector = state => state.cookieHandler.get('possibleLoanId')
export const hasSeenNewNavBarHighlightSelector = state =>
  state.cookieHandler.get('hasSeenNewNavBarHighlight')
